<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">

    <div v-if="!showDetails"
         class="layout-column flex ma-2"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">
      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1"
                  @click="getDataForTable()"
                  icon="refresh"
                  tooltip="Ansicht aktualisieren"
                  hide-label></lx-btn>
          <lx-btn small classes="mr-1"
                  @click="openDetails()"
                  icon="mdi-playlist-plus"
                  :tooltip="$t('COMPONENT_INSURANCE_COMPANY.BUTTON.ADD_NEW')"
                  hide-label></lx-btn>
        </div>

        <div class="flex layout-row mr-1">
          <!--          <lx-search-field-->
          <!--            placeholder="Suchbegriff (Nachname, Vorname, Loginname, Email)"-->
          <!--            dense-->
          <!--            v-model="tableObj.filterValue"-->
          <!--            :data-method="getDataForTable"-->
          <!--          ></lx-search-field>-->
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">
        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="InsuranceCompanyList"
              v-model="tableObj.selection"
              :items="items"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :tableOptions="tableObj.options"
              @changeOptions="changeTableOptions"
              @rowClicked="openDetails">

              <template #cellrenderer="{ value }">
                <div v-if="value.f.renderer === 'delete'"
                     style="cursor:pointer;"
                     class="layout-align-center-start">
                  <v-icon :color="compColor.primeColor" @click="openDeleteDialog(value.i, $event)">mdi-delete-forever</v-icon>
                </div>

                <div v-if="value.f.renderer === 'insuranceType'" class="layout-align-center-start">
                  <span>{{ $t('COMPONENT_INSURANCE_COMPANY.INSURANCE_TYPES.' + value.i.insurance_type.toUpperCase()) }}</span>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'PhysiciansList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable"></lx-pagination>
      </div>
    </div>

    <insurance-company-details v-if="showDetails"
                               @set-show-details="setShowDetails"
                               :insuranceCompanyId="selectedId">
    </insurance-company-details>
  </div>
</template>
<script>
import LxPagination from '../../../components/lx_pagination/LxPagination'
import InsuranceCompanyDetails from './InsuranceCompanyDetails'

export default {
  name: 'InsuranceCompanyList',
  data () {
    return {
      tableObj: {
        loading: false,
        selection: null,
        filterValue: null,
        options: {
          sortBy: ['name'],
          sortDesc: [false],
        },
        headers: [
          {
            text: this.$t('COMPONENT_INSURANCE_COMPANY.TABLE.NAME'),
            value: 'name',
            sortable: true,
            width: '400px'
          },
          {
            text: this.$t('COMPONENT_INSURANCE_COMPANY.TABLE.IK'),
            value: 'ik',
            sortable: true,
            width: '200px'
          },
          {
            text: this.$t('COMPONENT_INSURANCE_COMPANY.TABLE.INSURANCE_TYPE'),
            value: 'insurance_type',
            sortable: true,
            width: '200px',
            renderer: 'insuranceType'
          },
          {
            text: '',
            value: '',
            class: 'text-center',
            bodyClass: 'text-center',
            width: '50px',
            renderer: 'delete'
          }
        ]
      },
      items: [],
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      showDetails: false,
      selectedId: null,
      deleteDialogTitle: this.$t('CONFIRM_DELETE_DIALOG.HEADER'),
      deleteDialogMessage: this.$t('CONFIRM_DELETE_DIALOG.MESSAGE_DELETE_FORM'),
      deleteDialogOpts: {
        ok: this.$t('buttons.delete.value'),
        cancel: this.$t('buttons.cancel.value')
      }
    }
  },

  components: {
    InsuranceCompanyDetails,
    LxPagination
  },

  created () {
    this.getDataForTable()
  },

  methods: {
    /**
     * Open Dialog to confirm or decline delete of selected cancer registers
     */
    openDeleteDialog (params, event) {
      if (event) {
        event.stopPropagation()
      }

      this.DialogConfirm(
        this.deleteDialogTitle,
        this.deleteDialogMessage,
        this.deleteDialogOpts)
        .then(() => {
          if (params && params._id) {
            this.$http.delete('/additionalInsuranceCompanies/' + params._id)
              .then(res => {
                this.removeTabIfDatasetWasDeleted({
                  routeName: 'InsuranceCompanyDetails',
                  routeParams: { registerId: params._id }
                })

                this.NotifySuccess(res, 'Der Datensatz wurde erfolgreich gelöscht.')
                this.getDataForTable()
              })
              .catch(this.NotifyError)
          }
        })
        .catch(() => {
        })
    },

    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * Load Detail Page in the same frame
     */
    openDetails (params) {
      this.selectedId = null

      if (params) {
        this.selectedId = params._id
      }
      this.setShowDetails(true)
    },

    /**
     * Wird verschiedenen Stellen aus aufgerufen und soll die Daten vom Backend abholen.
     * Besonderheit:
     * "this.pagingOptions.count = res.data.count"
     * - Anzahl der Datensätze vom Server wird auch in den pagingOptions gespeichert
     *
     * "this.$store.dispatch('setPagingOptions', this.pagingOptions)"
     * - nach der Speicherung der Anzahl werden die pagingOptions wieder in den Store geschrieben
     *
     * "this.gridOptions.api.ensureIndexVisible(this.$store.getters.gridScrollIndex, 'top')"
     * - sorgt dafür das nach dem neuladen der Daten das Grid wieder an die Stelle scrollt wo es war. notwendig z.B. bei der Rückkehr zum Grid
     * **/
    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      // if (this.tableObj.filterValue) {
      //   query['$searching'] = this.tableObj.filterValue
      // }

      this.$http.get('/additionalInsuranceCompanies?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          if (res.data) {
            this.items = res.data || []

            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    setShowDetails (showDetails) {
      if (!showDetails) {
        this.getDataForTable()
      }
      this.showDetails = showDetails
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'InsuranceCompanyList' && !this.showDetails) {
        this.getDataForTable()
      }
    }
  }
}
</script>
